import type { Rng } from './rng';

export interface Confronto {
  mandante: number;
  visitante: number;
}

/** Uma lista de confrontos por rodada. */
export type Calendario = Confronto[][];

/**
 * Pontos corridos em dois turnos (método do círculo). Com n clubes (par) saem 2(n-1) rodadas e cada clube joga
 * uma vez por rodada. O returno repete o primeiro turno com os mandos invertidos.
 */
export function gerarCalendario(ids: number[], rng: Rng): Calendario {
  if (ids.length < 2 || ids.length % 2 !== 0) throw new Error('número de clubes deve ser par e >= 2');
  const n = ids.length;
  const ordem = rng.embaralhar([...ids]);
  const turno1: Calendario = [];
  for (let r = 0; r < n - 1; r++) {
    const rodada: Confronto[] = [];
    for (let i = 0; i < n / 2; i++) {
      const a = ordem[i] as number;
      const b = ordem[n - 1 - i] as number;
      // alterna o mando para equilibrar casa/fora
      const inverter = (r + i) % 2 === 1;
      rodada.push(inverter ? { mandante: b, visitante: a } : { mandante: a, visitante: b });
    }
    turno1.push(rodada);
    const fixo = ordem[0] as number;
    const resto = ordem.slice(1);
    resto.unshift(resto.pop() as number);
    ordem.splice(0, ordem.length, fixo, ...resto);
  }
  const turno2 = turno1.map((rodada) => rodada.map((c) => ({ mandante: c.visitante, visitante: c.mandante })));
  return [...turno1, ...turno2];
}

export interface ResultadoJogo {
  rodada: number;
  mandante: number;
  visitante: number;
  gols: [number, number];
}

export interface LinhaTabela {
  clubeId: number;
  pj: number;
  v: number;
  e: number;
  d: number;
  gp: number;
  gc: number;
  sg: number;
  pts: number;
}

export function calcularTabela(ids: number[], resultados: ResultadoJogo[]): LinhaTabela[] {
  const linhas = new Map<number, LinhaTabela>();
  for (const id of ids) linhas.set(id, { clubeId: id, pj: 0, v: 0, e: 0, d: 0, gp: 0, gc: 0, sg: 0, pts: 0 });
  for (const r of resultados) {
    const m = linhas.get(r.mandante);
    const v = linhas.get(r.visitante);
    if (!m || !v) continue;
    m.pj++;
    v.pj++;
    m.gp += r.gols[0];
    m.gc += r.gols[1];
    v.gp += r.gols[1];
    v.gc += r.gols[0];
    if (r.gols[0] > r.gols[1]) {
      m.v++;
      m.pts += 3;
      v.d++;
    } else if (r.gols[0] < r.gols[1]) {
      v.v++;
      v.pts += 3;
      m.d++;
    } else {
      m.e++;
      v.e++;
      m.pts++;
      v.pts++;
    }
  }
  const lista = [...linhas.values()];
  for (const l of lista) l.sg = l.gp - l.gc;
  // critérios: pontos, vitórias, saldo de gols, gols pró, id (determinístico)
  return lista.sort((a, b) => b.pts - a.pts || b.v - a.v || b.sg - a.sg || b.gp - a.gp || a.clubeId - b.clubeId);
}
